export const COMMON_COLORS = {
  WHITE: "#ffffff",
  SUCCESS_GREEN: "#008c33",
  ERROR_RED: " #c90000",
  ERROR_RED_WEBSITE: "#FF6B47",
  WARNING_YELLOW: "#fFC600",
  WEBSITE_GREEN: "#D4F39A40",
  WEBSITE_GREEN_LIGHT: "var(--loder-color)",
  WEBSITE_DRAWER_HEADER_BG: "#1a1a1a",
  BLACK: "#000000",
  GRAY: "#00000060",
  GRAY_LIGHT: "#808080",
  PRIMARY_COLOR: "#434db8",
  LOADER_OVERLAY: "var(--color-black13)",
};
export const BTN_COLORS = {
  BTN_TEXT_COLOR: "#ffffff",
};

export const DROP_ZONE_COLORS = {
  ACTIVE_DRAG_BG: "#f0f0f0",
};

export const ICON_COLOR_CONSTANTS = {
  FILTER_COLOR_ICON: "var(--password-view-icon-color)",
  DELETE_COLOR_ICON: "#A91224",
  EDIT_COLOR_ICON: "#808080",
  BTN_COLOR_BODY: "#434DB8",
  VERT_SEPERATOR_COLOR: "#D0D0D0",
  REPLACE_COLOR_COLOR: "#808080",
  ARROW_ICON_COLOR: "#808080",
  TEXT_COLOR: "var(--password-validation-txt-color)",
  CLOSE_ICON_COLOR: "#E0E0E0",
  BROWN_ICON_WEBSITE: "#B2B2B2",
};

export const CREATE_SYLLABUS_COLOR_CONSTANTS = {
  HEADER_BODY_COLOR: "#434DB8",
  CREATE_SYLLABUS_SUB_HEAD: "#2E2230",
  SYLLABUS_TEXT_COLOR: "#3c3838",
  BTN_BG_COLOR: "#FFFFFF",
};

export const BREADCRUMB_COLOR_CONSTANTS = {
  SEPARATOR_COLOR: "#c2d2fb",
  TEXT_COLOR: "#3c3838",
};

export const PHONE_INPUT_COLOR = {
  BORDER_COLOR: "1px solid #a3a3a3",
  FOCUS_BORDER_COLOR: "1px solid #434db8",
};

export const QUESTION_COUNT_INFO = {
  totalQuestions: "#4B9CD3",
  globalQuestions: "#4D3d5e",
  approvedQuestions: "#4CAF50",
  pendingQuestions: "#C9AA06",
  rejectedQuestions: "#FE0000",
  myQuestions: "#71347B",
};

export const QUIZ_SCREEN_COLORS = {
  HEADER_COLOR: "#CCD6EA",
  ACCEPTED: "#5CA700",
  FAILED: "#C50303",
};

export const DISABLED_CODE_EDITOR_COLOR = {
  GRAY_BG: "#EDEDED",
  GRAY_BG_TEXT: "#3C3838",
  BLACK_BG: "#2B2B2B",
  BLACK_BG_TEXT: "#FFF",
  WHITE_BG: "#FFF",
  WHITE_BG_TEXT: "#2B2B2B",
};

export const WORKSPACE_COLOR_CONSTANTS = {
  HEADER_BG_COLOR: "#F9F9F9",
  HEADER_TEXT_COLOR: "#575757",
};

export const INSTRUCTION_PAGE_COLORS = {
  TEXT_COLOR: "#575757",
};

export const ROLES_SWITCH_BG: Record<string, { bgColor: string }> = {
  SUBJECT_OWNER: { bgColor: "#83018F" },
  QUESTION_ADDER: { bgColor: "#A51618" },
  QUESTION_VERIFIER: { bgColor: "#10502F" },
  SUPER_USER: { bgColor: "#83018F" },
  STUDENT: { bgColor: "#003871" },
  TRAINER: { bgColor: "#A78C00" },
};

export const ORG_SWITCH_BG: string[] = [
  "#83018F",
  "#A51618",
  "#10502F",
  "#003871",
  "#A78C00",
];

export const BATCH_CARD_COLORS = [
  "#71347B",
  "#7AA5C8",
  "#F9B75B",
  "#FA817C",
  "#434DB8",
  "#D8C7B0",
];

export const WEBSITE_COLORS = {
  DARK_GRAY: "#161616",
  GREEN_THEME: "#008C33",
  DARK_GRAY_SHADE_2: "#161616",
  TEXT_COLOR_GRAY: "#808080",
  DARK_GREEN: "#008C33",
  GREEN_700: "#16552D",
  TEXT_COLOR: "#808080",
  LOGIN_MODAL_HEADER_COLOR: "#fafafa",
  LOGIN_MODAL_SUB_HEADER_COLOR: "#A5A5A5",
};

export const STUDENT_ELP_STATUS_COLORS = {
  IN_PROGRESS: "#FF8B00",
  COMPLETED: "#5CA700",
  ABSENT: "#C50303",
};

export const REPORT_ANALYTICS_COLORS = {
  GREEN: "rgba(92, 167, 0, 1)",
  PRIMARY: "rgba(67, 77, 184, 1)",
  SECONDARY: "rgba(255, 198, 0, 1)",
  TERTIARY: "rgba(197, 3, 3, 1)",
  GREEN_BG: "rgba(92, 167, 0,0.1)",
  PRIMARY_BG: "rgba(67, 77, 184, 0.2)",
  SECONDARY_BG: "rgba(255, 198, 0, 0.2)",
  TERTIARY_BG: "rgba(197, 3, 3, 0.2)",
};
